import { render } from "./ModelColorAdd.vue?vue&type=template&id=6f80d336"
import script from "./ModelColorAdd.vue?vue&type=script&lang=js"
export * from "./ModelColorAdd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__